import React from "react";
import useStore from "../../../../context/useStore";
import useManagers from "../../../../hooks/useManagers/useManagers";
import useProducers from "../../../../hooks/useProducers/useProducers";
import useLeads from "../useLeads";
import useLeadFilters from "./useLeadFilters";
import { buildFilterTokens } from "./filterTokens";

const ActiveFiltersSummary = () => {
  const [state] = useStore();
  const { managers } = useManagers();
  const { producers } = useProducers(true);
  const { leadCount, isListInit, productCategory } = useLeads();
  const { leadsFilters, actions } = useLeadFilters();
  const { QUOTATION_PRODUCT_TYPES, QUOTE_PRODUCT_TYPES, LEAD_STATUS, LEAD_TASKS } =
    state.constants.items;
  const userId = state.auth?.user?.id;

  const products =
    productCategory === "DOMI" ? QUOTE_PRODUCT_TYPES : QUOTATION_PRODUCT_TYPES;

  const tokens = buildFilterTokens(leadsFilters.filters, {
    userId,
    managers,
    LEAD_STATUS,
    products,
    producers,
    leadTasks: LEAD_TASKS,
  });

  if (!tokens.length) return null;

  return (
    <div className="lf-summary">
      <span className="lf-lbl">FILTRES</span>
      {tokens.map((t) => (
        <span key={t.key} className="lf-token">
          <span>{t.label}</span>
          <button
            type="button"
            className="lf-x"
            onClick={() => actions.removeFilterToken(t.clear)}
            aria-label={`Retirer le filtre ${t.label}`}
          >
            <i className="fa fa-times" />
          </button>
        </span>
      ))}
      <span className="lf-right">
        {isListInit && (
          <span className="lf-count-res">
            {leadCount.toLocaleString("fr-FR")} résultat
            {leadCount > 1 ? "s" : ""}
          </span>
        )}
        <button
          type="button"
          className="lf-clear"
          onClick={actions.clearAllFilters}
        >
          Tout effacer
        </button>
      </span>
    </div>
  );
};

export default ActiveFiltersSummary;
